import React from "react"
import ReactDOM from "react-dom"
import "./styles/index.css"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import { BrowserRouter } from "react-router-dom"
import { CookiesProvider } from "react-cookie"

export const Index: React.FC<{}> = (): JSX.Element => {
  return (
    <React.StrictMode>
      <BrowserRouter>
        <CookiesProvider>
          <App />
        </CookiesProvider>
      </BrowserRouter>
    </React.StrictMode>
  )
}
// https://github.com/stereobooster/react-snap
const rootElement = document.getElementById("root")
if (rootElement?.hasChildNodes()) {
  ReactDOM.hydrate(<Index />, rootElement)
} else {
  ReactDOM.render(<Index />, rootElement)
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
